<template>
  <DxPopup
    :visible="visible"
    :title="title"
    :width="420"
    height="auto"
    :drag-enabled="false"
    :close-on-outside-click="false"
    :show-close-button="true"
    @hiding="$emit('cancel')"
  >
    <div class="zero-weight-confirm-content">
      <div class="zero-weight-confirm-message">
        {{ message }}
      </div>
      <div class="zero-weight-confirm-actions">
        <SmagriaButton
          :label="$t('common.yes')"
          :action="onConfirm"
          :customClass="'primary'"
          :width="160"
        />
        <SmagriaButton
          :label="$t('common.no')"
          :action="onCancel"
          :customClass="'reset border'"
          :width="160"
        />
      </div>
    </div>
  </DxPopup>
</template>

<script>
import { DxPopup } from "devextreme-vue/popup";
import SmagriaButton from "@/components/Common/SmagriaButton.vue";

export default {
  name: "ZeroWeightConfirmDialog",
  components: { DxPopup, SmagriaButton },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
  },
  methods: {
    onConfirm() {
      this.$emit("confirm");
    },
    onCancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped>
.zero-weight-confirm-content {
  padding: 10px 4px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.zero-weight-confirm-message {
  font-size: 14px;
  line-height: 1.4;
  color: #2c2c2c;
}

.zero-weight-confirm-actions {
  display: flex;
  justify-content: center;
  gap: 8px;
}
</style>
